import { useLocation } from 'react-router-dom'

export function useGetCurrentEndpoint() {
  const location = useLocation()
  const currentEndpoint = location.pathname.split('/')[location.pathname.split('/').length - 1]
  return currentEndpoint
}
